import api from "@core/plugins/api";
export const familyEtabUrl = () => `familles/categories`;

export class EtabFamilyService {
  /**
   * Retrieve Families and categories
   * @static
   * @returns {Array}
   */
  static async getFamiliesList() {
    try {
      const response = await api.public.get(familyEtabUrl());
      return response && response.data;
    } catch (error) {
      throw error;
    }
  }
}
